import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconChevronRight } from '@travel-frontend/icons';
import { Container } from '../../../../../../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLinks/PromotionItems/components/Item/components/Content/components/Container.js';
import { IconWrapper } from '../../../../../../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLinks/PromotionItems/components/Item/components/Content/components/IconWrapper.js';
import { Image } from '../../../../../../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLinks/PromotionItems/components/Item/components/Content/components/Image.js';
import { LabelMediumBold, LabelSmall, Stack } from '../../../../../../../../../../../primitives/index.js';
export const Content = ({
  item,
  imageUrl,
  isLink = false,
  onClick
}) => {
  return _jsxs(Container, {
    direction: 'row',
    justifyContent: 'space-between',
    onClick: onClick,
    children: [_jsxs(Stack, {
      direction: 'row',
      spacing: 'small',
      children: [item.image && _jsx(Image, {
        src: imageUrl,
        alt: item.text
      }), _jsxs(Stack, {
        spacing: 'none',
        children: [_jsx(LabelMediumBold, {
          children: item.text
        }), item.description && _jsx(LabelSmall, {
          color: "contentSecondary",
          children: item.description
        })]
      })]
    }), isLink && _jsx(IconWrapper, {
      children: _jsx(IconChevronRight, {
        color: 'interactionSecondary'
      })
    })]
  });
};